import React from 'react';
import Disclaimer from '../components/Disclaimer';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Disclaimer />
      <Header />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;

